import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, TransitionGroup as _TransitionGroup, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "home-body" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_Header = _resolveComponent("Header")!
  const _component_InfoBlock = _resolveComponent("InfoBlock")!
  const _component_RadioList = _resolveComponent("RadioList")!
  const _component_CheckboxList = _resolveComponent("CheckboxList")!
  const _component_FreeAnswer = _resolveComponent("FreeAnswer")!
  const _component_CSIBlock = _resolveComponent("CSIBlock")!
  const _component_RateBlock = _resolveComponent("RateBlock")!
  const _component_SliderBlock = _resolveComponent("SliderBlock")!
  const _component_FinalBlock = _resolveComponent("FinalBlock")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ErrorBlock = _resolveComponent("ErrorBlock")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["home", 
      _ctx.surveyInfo?.brand ? `--${_ctx.surveyInfo.brand?.toLowerCase()}` : '--kcell'
    ])
  }, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["theme-bg", 
        _ctx.currentEvent && _ctx.respStatus < 400 ? `${_ctx.currentEvent?.toLowerCase()}` : ''
      ])
        }, null, 2))
      : _createCommentVNode("", true),
    (!_ctx.isLoaded && _ctx.displayType !== 'ONE_PAGE')
      ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 1,
          indicator: _ctx.indicator,
          spinning: _ctx.responseLoading,
          class: "response-loader"
        }, null, 8, ["indicator", "spinning"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_spin, {
      indicator: _ctx.indicator,
      spinning: _ctx.isLoaded || _ctx.sendingRequestStatus
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["home-wrapper", { 'read-only': _ctx.sendingRequestStatus || _ctx.responseLoading }])
        }, [
          (
            _ctx.respStatus < 400 ||
            (_ctx.surveyInfo?.logoPosition !== 'WITHOUT' && _ctx.respStatus <= 400)
          )
            ? _withDirectives((_openBlock(), _createBlock(_component_Header, {
                key: 0,
                "instance-id": _ctx.instanceId,
                brand: _ctx.surveyInfo?.brand,
                currentLang: _ctx.surveyInfo?.lang,
                "logo-position": _ctx.surveyInfo?.logoPosition,
                "survey-status": _ctx.respStatus < 400,
                class: "home-top",
                onShowSpin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.responseLoading = _ctx.showSpin)),
                onEventAfterLangChange: _ctx.uploadSurvey
              }, null, 8, ["instance-id", "brand", "currentLang", "logo-position", "survey-status", "onEventAfterLangChange"])), [
                [_vShow, !_ctx.isLoaded]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.respStatus < 400)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.displayType !== 'ONE_PAGE')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!_ctx.isLoaded)
                            ? (_openBlock(), _createBlock(_component_swiper, {
                                key: 0,
                                direction: "vertical",
                                "slides-per-view": 1,
                                mousewheel: { eventsTarget: '.home' },
                                forceToAxis: true,
                                keyboard: { enabled: true, pageUpDown: true },
                                class: _normalizeClass(["home-slider", `--${_ctx.displayType?.toLowerCase()}`]),
                                onSwiper: _ctx.onSwiper
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q, index) => {
                                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                                      key: q.questionId,
                                      class: "home-slide"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, [
                                          (q.startBlock === true)
                                            ? (_openBlock(), _createBlock(_component_InfoBlock, {
                                                key: 0,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText
                                              }, null, 8, ["text"]))
                                            : _createCommentVNode("", true),
                                          (q.answerTemplate?.answerType === 'SINGLE_CHOICE')
                                            ? (_openBlock(), _createBlock(_component_RadioList, {
                                                key: 1,
                                                currentLang: _ctx.surveyInfo?.lang,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                choiceAnswer: 
                          q.answerTemplate.answerChoices.sort(_ctx.compare)
                        ,
                                                customAnswer: q.answerTemplate.addCustomAnswer,
                                                customTextAnswer: 
                          _ctx.surveyInfo?.lang === 'RU'
                            ? q.answerTemplate.customAnswerTextRu
                            : q.answerTemplate.customAnswerTextKk
                        ,
                                                verticalLayout: q.answerTemplate.verticalLayout,
                                                index: index,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["currentLang", "text", "choiceAnswer", "customAnswer", "customTextAnswer", "verticalLayout", "index", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (
                          q.answerTemplate?.answerType === 'MULTIPLE_CHOICE'
                        )
                                            ? (_openBlock(), _createBlock(_component_CheckboxList, {
                                                key: 2,
                                                currentLang: _ctx.surveyInfo?.lang,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                choiceAnswer: 
                          q.answerTemplate.answerChoices.sort(_ctx.compare)
                        ,
                                                customAnswer: q.answerTemplate.addCustomAnswer,
                                                customTextAnswer: 
                          _ctx.surveyInfo?.lang === 'RU'
                            ? q.answerTemplate.customAnswerTextRu
                            : q.answerTemplate.customAnswerTextKk
                        ,
                                                verticalLayout: q.answerTemplate.verticalLayout,
                                                index: index,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["currentLang", "text", "choiceAnswer", "customAnswer", "customTextAnswer", "verticalLayout", "index", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (q.answerTemplate?.answerType === 'CUSTOM')
                                            ? (_openBlock(), _createBlock(_component_FreeAnswer, {
                                                key: 3,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                customAnswerRequired: 
                          q.answerTemplate.customAnswerRequired
                        ,
                                                index: index,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["text", "customAnswerRequired", "index", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (q.answerTemplate?.answerType === 'CSI')
                                            ? (_openBlock(), _createBlock(_component_CSIBlock, {
                                                key: 4,
                                                currentLang: _ctx.surveyInfo?.lang,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                csiAnswers: q.answerTemplate.csiParams,
                                                csiScale: q.answerTemplate.csiScale,
                                                index: index,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["currentLang", "text", "csiAnswers", "csiScale", "index", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (q.answerTemplate?.answerType === 'RATING')
                                            ? (_openBlock(), _createBlock(_component_RateBlock, {
                                                key: 5,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                index: index,
                                                status: _ctx.sendingRequestStatus || _ctx.responseLoading,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["text", "index", "status", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (q.answerTemplate?.answerType === 'SLIDER')
                                            ? (_openBlock(), _createBlock(_component_SliderBlock, {
                                                key: 6,
                                                currentLang: _ctx.surveyInfo?.lang,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                                answerSlider: q.answerTemplate.answerSlider,
                                                index: index,
                                                status: _ctx.sendingRequestStatus || _ctx.responseLoading,
                                                onAnswersFields: _ctx.updateAnswerFields
                                              }, null, 8, ["currentLang", "text", "answerSlider", "index", "status", "onAnswersFields"]))
                                            : _createCommentVNode("", true),
                                          (q.endBlock === true)
                                            ? (_openBlock(), _createBlock(_component_FinalBlock, {
                                                key: 7,
                                                text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText
                                              }, null, 8, ["text"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["class", "onSwiper"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (!_ctx.isLoaded)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["one-page", `--${_ctx.displayType?.toLowerCase()}`])
                              }, [
                                _createVNode(_TransitionGroup, {
                                  name: "fade-slide",
                                  tag: "div",
                                  appear: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleQuestions, (q, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: q.questionId,
                                        class: "card fade-item"
                                      }, [
                                        (q.startBlock === true)
                                          ? (_openBlock(), _createBlock(_component_InfoBlock, {
                                              key: 0,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText
                                            }, null, 8, ["text"]))
                                          : _createCommentVNode("", true),
                                        (q.answerTemplate?.answerType === 'SINGLE_CHOICE')
                                          ? (_openBlock(), _createBlock(_component_RadioList, {
                                              key: 1,
                                              currentLang: _ctx.surveyInfo?.lang,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              choiceAnswer: 
                          q.answerTemplate.answerChoices.sort(_ctx.compare)
                        ,
                                              customAnswer: q.answerTemplate.addCustomAnswer,
                                              customTextAnswer: 
                          _ctx.surveyInfo?.lang === 'RU'
                            ? q.answerTemplate.customAnswerTextRu
                            : q.answerTemplate.customAnswerTextKk
                        ,
                                              verticalLayout: q.answerTemplate.verticalLayout,
                                              index: index,
                                              type: "ONE_PAGE",
                                              onAnswersFields: _ctx.updateAnswerFields,
                                              onNextQuestion: _ctx.nextAnswer
                                            }, null, 8, ["currentLang", "text", "choiceAnswer", "customAnswer", "customTextAnswer", "verticalLayout", "index", "onAnswersFields", "onNextQuestion"]))
                                          : _createCommentVNode("", true),
                                        (
                          q.answerTemplate?.answerType === 'MULTIPLE_CHOICE'
                        )
                                          ? (_openBlock(), _createBlock(_component_CheckboxList, {
                                              key: 2,
                                              currentLang: _ctx.surveyInfo?.lang,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              choiceAnswer: 
                          q.answerTemplate.answerChoices.sort(_ctx.compare)
                        ,
                                              customAnswer: q.answerTemplate.addCustomAnswer,
                                              customTextAnswer: 
                          _ctx.surveyInfo?.lang === 'RU'
                            ? q.answerTemplate.customAnswerTextRu
                            : q.answerTemplate.customAnswerTextKk
                        ,
                                              verticalLayout: q.answerTemplate.verticalLayout,
                                              index: index,
                                              type: "ONE_PAGE",
                                              onAnswersFields: _ctx.updateAnswerFields,
                                              onNextQuestion: _ctx.nextAnswer
                                            }, null, 8, ["currentLang", "text", "choiceAnswer", "customAnswer", "customTextAnswer", "verticalLayout", "index", "onAnswersFields", "onNextQuestion"]))
                                          : _createCommentVNode("", true),
                                        (q.answerTemplate?.answerType === 'CUSTOM')
                                          ? (_openBlock(), _createBlock(_component_FreeAnswer, {
                                              key: 3,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              customAnswerRequired: 
                          q.answerTemplate.customAnswerRequired
                        ,
                                              index: index,
                                              "current-lang": _ctx.surveyInfo?.lang === 'RU' ? 'RU' : 'KK',
                                              type: "ONE_PAGE",
                                              onNextQuestion: _ctx.nextAnswer,
                                              onAnswersFields: _ctx.updateAnswerFields
                                            }, null, 8, ["text", "customAnswerRequired", "index", "current-lang", "onNextQuestion", "onAnswersFields"]))
                                          : _createCommentVNode("", true),
                                        (q.answerTemplate?.answerType === 'CSI')
                                          ? (_openBlock(), _createBlock(_component_CSIBlock, {
                                              key: 4,
                                              currentLang: _ctx.surveyInfo?.lang,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              csiAnswers: q.answerTemplate.csiParams,
                                              csiScale: q.answerTemplate.csiScale,
                                              index: index,
                                              onAnswersFields: _ctx.updateAnswerFields,
                                              type: "ONE_PAGE"
                                            }, null, 8, ["currentLang", "text", "csiAnswers", "csiScale", "index", "onAnswersFields"]))
                                          : _createCommentVNode("", true),
                                        (q.answerTemplate?.answerType === 'RATING')
                                          ? (_openBlock(), _createBlock(_component_RateBlock, {
                                              key: 5,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              index: index,
                                              status: _ctx.sendingRequestStatus || _ctx.responseLoading,
                                              onAnswersFields: _ctx.updateAnswerFields,
                                              type: "ONE_PAGE"
                                            }, null, 8, ["text", "index", "status", "onAnswersFields"]))
                                          : _createCommentVNode("", true),
                                        (q.answerTemplate?.answerType === 'SLIDER')
                                          ? (_openBlock(), _createBlock(_component_SliderBlock, {
                                              key: 6,
                                              currentLang: _ctx.surveyInfo?.lang,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText,
                                              answerSlider: q.answerTemplate.answerSlider,
                                              index: index,
                                              status: _ctx.sendingRequestStatus || _ctx.responseLoading,
                                              onAnswersFields: _ctx.updateAnswerFields,
                                              type: "ONE_PAGE"
                                            }, null, 8, ["currentLang", "text", "answerSlider", "index", "status", "onAnswersFields"]))
                                          : _createCommentVNode("", true),
                                        (
                          q.endBlock === true &&
                          q.answerTemplate.answerType === 'NO_ANSWER'
                        )
                                          ? (_openBlock(), _createBlock(_component_FinalBlock, {
                                              key: 7,
                                              text: _ctx.surveyInfo?.lang === 'RU' ? q.ruText : q.kkText
                                            }, null, 8, ["text"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isVisibleSkeleton)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_a_skeleton, {
                                        active: "",
                                        paragraph: { rows: Math.floor(Math.random() * 5) + 4 }
                                      }, null, 8, ["paragraph"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64)),
                    (!_ctx.isLoaded)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (_ctx.displayType === 'ALL' && _ctx.questions.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.isValid)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      class: _normalizeClass(["home-btn", {
                      'is-disabled': _ctx.sendingRequestStatus || _ctx.responseLoading,
                    }]),
                                      disabled: _ctx.sendingRequestStatus || _ctx.responseLoading,
                                      onClick: _withModifiers(_ctx.sendAnswers, ["prevent"])
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.surveyInfo?.lang === 'KK')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Жіберу"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_6, "Отправить"))
                                      ]),
                                      _: 1
                                    }, 8, ["class", "disabled", "onClick"]))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      class: _normalizeClass(["home-btn", {
                      'is-disabled': _ctx.responseLoading || _ctx.questions.length <= 1,
                    }]),
                                      disabled: _ctx.responseLoading || _ctx.questions.length <= 1,
                                      onClick: _withModifiers(_ctx.nextSlide, ["prevent"])
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.surveyInfo?.lang === 'KK')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Келесi"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_8, "Далее"))
                                      ]),
                                      _: 1
                                    }, 8, ["class", "disabled", "onClick"]))
                              ], 64))
                            : (
                    _ctx.displayType !== 'ONE_PAGE' &&
                    _ctx.questions[0]?.endBlock !== true
                  )
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  class: _normalizeClass(["home-btn", {
                    'is-disabled': _ctx.responseLoading || !_ctx.answerValidation[0],
                  }]),
                                  disabled: _ctx.responseLoading || !_ctx.answerValidation[0],
                                  onClick: _withModifiers(_ctx.nextAnswer, ["prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.surveyInfo?.lang === 'KK')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Келесi"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "Далее"))
                                  ]),
                                  _: 1
                                }, 8, ["class", "disabled", "onClick"]))
                              : (
                    _ctx.displayType === 'ONE_PAGE' &&
                    _ctx.visibleQuestions.length === _ctx.allQuestions.length
                  )
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 2,
                                    class: _normalizeClass(["home-btn one-page", {
                    'is-disabled': _ctx.responseLoading || !_ctx.allRequiredAnswered,
                  }]),
                                    disabled: _ctx.responseLoading || !_ctx.allRequiredAnswered,
                                    onClick: _withModifiers(_ctx.sendAnswerOnePage, ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.surveyInfo?.lang === 'KK')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Сауалнаманы аяқтаңыз"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "Завершить опрос"))
                                    ]),
                                    _: 1
                                  }, 8, ["class", "disabled", "onClick"]))
                                : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_component_ErrorBlock, {
                    key: 1,
                    "error-code": _ctx.errorCode,
                    currentLang: _ctx.surveyInfo?.lang,
                    brand: _ctx.surveyInfo?.brand,
                    kkText: _ctx.kkText,
                    ruText: _ctx.ruText
                  }, null, 8, ["error-code", "currentLang", "brand", "kkText", "ruText"]))
            ])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["indicator", "spinning"])
  ], 2))
}